import { render, staticRenderFns } from "./imgM.vue?vue&type=template&id=779433e6&scoped=true"
var script = {}
import style0 from "./imgM.vue?vue&type=style&index=0&id=779433e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779433e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779433e6')) {
      api.createRecord('779433e6', component.options)
    } else {
      api.reload('779433e6', component.options)
    }
    module.hot.accept("./imgM.vue?vue&type=template&id=779433e6&scoped=true", function () {
      api.rerender('779433e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgM.vue"
export default component.exports